import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-v5';
import { bindActionCreators, Dispatch } from 'redux';
import { IAppState } from 'spw-redux/reducer';
import { actions } from 'spw-redux/modules/auth/actions';
import { EMAIL_REGEX } from 'spw-constants';
import {
  DialogBox,
  DialogCustom,
  FormColumns,
  GradientBackgroundContainer,
  Title,
  TextField,
  ButtonCustom,
  ErrorMessage,
} from '../styles';

interface ISendEmailDispatch {
  setEmail: (email: string) => void;
  sendRecoveryEmail: (params: { email: string }) => void;
}

interface IEmail {
  email: string;
  error: string;
}

type IProps = IEmail & ISendEmailDispatch & RouteComponentProps;

const SendEmail = ({ email, error, setEmail, sendRecoveryEmail }: IProps) => {
  const validEmail = useMemo(() => email.match(EMAIL_REGEX), [email]);

  return (
    <GradientBackgroundContainer>
      <DialogBox>
        <DialogCustom>
          <Title>Space Plan Wizard</Title>
          <FormColumns>
            <TextField
              label="Email"
              variant="outlined"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              helperText=" "
            />
            <ButtonCustom
              variant="contained"
              onClick={() => sendRecoveryEmail({ email })}
              disabled={!validEmail}
            >
              Send Recovery Link
            </ButtonCustom>
          </FormColumns>
          <ErrorMessage bottom="24px">{error}</ErrorMessage>
        </DialogCustom>
      </DialogBox>
    </GradientBackgroundContainer>
  );
};

const mapStateToProps = (state: IAppState): IEmail => ({
  email: state.authReducer.email,
  error: state.authReducer.error,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const { setEmail, sendRecoveryEmail } = actions;

  return bindActionCreators(
    {
      setEmail,
      sendRecoveryEmail,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SendEmail);
